module.exports = __webpack_public_path__ + "img/logo-sia.b5a0e358.png";